import { aomGraphqlRequest } from 'core/utils/backend-service';
import { mapTrainingProgramInfoFromApiToVm, VM } from '../domain';
import { getAllTrainingProgramsInfo } from './training-program-info.queries';

export const getTrainingProgramsInfo = (): Promise<VM.TrainingProgramInfo[]> =>
    aomGraphqlRequest(getAllTrainingProgramsInfo()).then((response) =>
        response.data.trainingProgramsInfo.map(mapTrainingProgramInfoFromApiToVm)
    );
